import {NgModule} from '@angular/core';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {XhAnonymizePage} from "./page/overview/anonymize/xh-anonymize.page";
import {XH_ENTITY_PROVIDER} from "./xh.entity-provider";
import {CoreModule} from "../../core/core.module";
import {XH_TEST_PROVIDERS} from "./test/xh-test-definition";

@NgModule({
  declarations: [
    XhAnonymizePage
  ],
  exports:[
    XhAnonymizePage
  ],
  imports: [
    CoreModule,
    ProgressSpinnerModule,
  ],
  providers: [XH_ENTITY_PROVIDER, XH_TEST_PROVIDERS]
})
export class XhModule { }

 
 
